import spacerStyles from './Space.module.css';

export default function VSpace({ size }: { size: 1 | 2 | 3 | 4 | 5 | 6 }) {
  return (
    <div
      className={[spacerStyles.space, spacerStyles[`space-${size}`]].join(' ')}
    />
  );
}
